// extracted by mini-css-extract-plugin
export var boldText = "_7s-4";
export var checkboxContainer = "_7s-6";
export var closeIcon = "_7s-i";
export var container = "_7s-0";
export var drawer = "_7s-8";
export var drawerContent = "_7s-9";
export var extraSmallText = "_7s-5";
export var fulfillmentGroupTable = "_7s-e";
export var largeText = "_7s-3";
export var loadingSpinnerContainer = "_7s-j";
export var mediumText = "_7s-2";
export var narrow = "_7s-f";
export var notificationLink = "_7s-l";
export var packageCheckIconContainer = "_7s-7";
export var slideoutHeaderActions = "_7s-g";
export var slideoutHeaderActionsShifted = "_7s-h";
export var slideoutHeaderContainer = "_7s-a";
export var slideoutModal = "_7s-c";
export var stickyHeaderWrapper = "_7s-b";
export var table = "_7s-k";
export var tableContainer = "_7s-d";
export var tertiaryText = "_7s-1";